/* Package JSON Import will be here */
import { forEach, sortBy, reverse, filter, includes } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { applyFilterApi, repeatMyLastOrderApi } from "services/products";
import { mergeMultipleSchemeProducts, getErrorObject, normalizeByGroup } from "utilities/utils";
import { loadSmartListProducts } from "reducers/orders";
import Constants from 'utilities/appConstants';
/* Project Import will be here */

const types = {
    PRODUCTS_PRELOAD: "PRODUCTS_PRELOAD",
    PRELOAD_PRODUCTS_REQUEST: "PRELOAD_PRODUCTS_REQUEST",
    PRELOAD_PRODUCTS_FAILURE: "PRELOAD_PRODUCTS_FAILURE",
    PRELOAD_PRODUCTS_UPDATE_IS_FAV: "PRELOAD_PRODUCTS_UPDATE_IS_FAV",
    RESET_PRELOAD_PRODUCTS: "RESET_PRELOAD_PRODUCTS"
};

const initialState = {
    groupIds: [],
    group: {},
    isLoading: false,
    ids: [],
    data: {},
    count: null,
    error: null,
    originalData: [],
    pageType: ""
};

export const productPreloadQty = (state = initialState, action) => {
    switch (action.type) {
        case types.PRELOAD_PRODUCTS_REQUEST:
            return {
                ...initialState,
                ...action.payload,
                isLoading: true
            };
        case types.PRODUCTS_PRELOAD:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.PRELOAD_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.RESET_PRELOAD_PRODUCTS:
            return {
                ...initialState
            };
        case types.PRELOAD_PRODUCTS_UPDATE_IS_FAV:
            let { ProductId, IsFavourite } = action.payload;
            if (ProductId in state.data) {
                return {
                    ...state,
                    data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
                    error: null,
                    isLoading: false
                }
            }
            else {
                return state;
            }
        default:
            return state;
    }
};

export const getProductPreloadQtyList = (type) => {
    return async (dispatch, getState) => {
        /* Check for any previous data applied */
        let selectedPreloadPageType = getState().productPreloadQty.pageType
        if (selectedPreloadPageType !== "" && type !== selectedPreloadPageType) {
            await dispatch({ type: types.RESET_PRELOAD_PRODUCTS });

            /* Trigger the API with empty initial data */
            dispatch(getProductPreloadQtyList(type));
        }
        else {
            dispatch({ type: types.PRELOAD_PRODUCTS_REQUEST, payload: { pageType: type } });
            try {
                const appSettings = getState().appSettings;

                /* Get the preload products list and merge multiple schemes */
                let response = null;
                if (type === Constants.REDUCER_SUGGESTED_PRODUCTS)
                    response = await applyFilterApi({ NeedRelevant: true });
                else
                    response = await repeatMyLastOrderApi({});
                let preloadProductList = mergeMultipleSchemeProducts(response.data.Data);

                /* check for min order qty */
                forEach(preloadProductList, (o) => {
                    if (o.MinORDQty > 1 && appSettings.isEnableMinOrderQty) {
                        if (o.Qty % o.MinORDQty !== 0) {
                            o.Qty = Math.ceil(o.Qty / o.MinORDQty) * o.MinORDQty;
                        }
                    }

                    /* Check for stock 0 */
                    if (appSettings.isRestrictSIHProducts && o.SIH === 0)
                        o.Qty = 0;
                });

                //TODO:Remove due to sequence sorting in initial commit
                // /* Default product sorting is name asc */
                // preloadProductList = sortBy(preloadProductList, o => { return o.ProductName });

                /* Get products by normalize group */
                let payload = normalizeByGroup({
                    data: preloadProductList,
                    key: "ProductId",
                    groupKey: "GroupId"
                });
                payload.count = preloadProductList.length;
                payload.originalData = preloadProductList;

                dispatch({ type: types.PRODUCTS_PRELOAD, payload });

                /* Load the preload products to order reducer */
                dispatch(loadSmartListProducts(payload, null, null, type === Constants.REDUCER_SUGGESTED_PRODUCTS ? true : false));
            }
            catch (error) {
                const { message } = getErrorObject(error);
                dispatch({
                    type: types.PRELOAD_PRODUCTS_FAILURE,
                    payload: { error: message }
                });
            }
        }
    };
};

export const sortAndSearchPreloadProducts = (sortType, searchText, restFilter = false) => {
    return async (dispatch, getState) => {
        try {
            const preloadProductData = getState().productPreloadQty.originalData;

            /* Default name asc sorting */
            let sortedPreloadProductList = sortBy(preloadProductData, o => { return o.ProductName });

            /* If sorting specify name desc */
            if (sortType === Constants.NAME_DESC)
                sortedPreloadProductList = reverse(sortedPreloadProductList);

            /* Apply search text filter */
            if (searchText !== "")
                sortedPreloadProductList = filter(sortedPreloadProductList, o => { return includes(o.ProductName.toLowerCase(), searchText.toLowerCase()) });

            /* Get products by normalize group */
            let payload = normalizeByGroup({
                data: !restFilter ? sortedPreloadProductList : preloadProductData,
                key: "ProductId",
                groupKey: "GroupId"
            });

            dispatch({ type: types.PRODUCTS_PRELOAD, payload });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.PRELOAD_PRODUCTS_FAILURE,
                payload: { error: message }
            });
        }
    };
};